import ChangeWalletDialog from '@/components/wallet/change-wallet-dialog';
import {
  CoinTwo,
  DownArrow,
  DownTriangle,
  More,
  Timer,
  UpArrow,
} from '@/ui/svg';
import { TokenChainIcon } from '@/ui/tokenImage';
import {
  useWallets,
  useGlobalValueStore,
  useCurrentWallet,
  useToken,
  usePoints,
} from '@bitbot/model';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import TotalUsdValue from '../common/total-usd-value';
import HomeTab from './home-tab';
import MoreDialog from './more-dialog';
import TradeSearch from './trade-search';
import HapticContainer from '../common/haptic-container';
import CopyWithContent from '../common/copy-with-content';
import CommonSkeleton from '../common/skeleton/common-skeleton';
import { Button } from '@/ui/buttons';
import Card from './card';
import { sendGAEvent } from '@next/third-parties/google';
import { postEventSafe } from '@/utils/platform';

export default function Index() {
  usePoints();
  const { tradeLoginStatus } = useToken();
  const [showChangeWallet, setShowChangeWallet] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const { currentWalletStats, initingWalletInfo } = useWallets();
  const { gettingWalletBalance, refetchWalletBalance, walletBalance } =
    useCurrentWallet();
  const { homeScrollRef, setShowCreateWalletAndLoginDialog } =
    useGlobalValueStore();
  useEffect(() => {
    if (walletBalance) {
      refetchWalletBalance();
    }
    postEventSafe('web_app_set_header_color', {
      color: '#000000',
    });
    sendGAEvent('event', 'home');
  }, []);

  return (
    <div className="h-screen overflow-scroll" ref={homeScrollRef}>
      <div className="bg-primary text-primary font-nunito_sans pt-2">
        {/* 1{initingWalletInfo ? (
          <div className="h-[200px] w-full p-4 flex flex-col gap-2">
            <CommonSkeleton className="w-[50vw] h-12" />
            <CommonSkeleton className="w-[70vw] h-12" />
            <CommonSkeleton className="w-[90vw] h-12" />
          </div>
        ) : tradeLoginStatus ? (
          <div className="px-4">
            {gettingWalletBalance ? (
              <CommonSkeleton className="w-[60vw] h-6" />
            ) : (
              <div className="flex items-center gap-2">
                <div
                  className="flex items-center cursor-pointer gap-2"
                  onClick={() => {
                    setShowChangeWallet(true);
                    sendGAEvent('event', 'click_home_wallet');
                  }}
                >
                  <div className="w-[1.2rem] h-[1.2rem]">
                    {currentWalletStats && (
                      <TokenChainIcon
                        src="/chain/base.svg"
                        name={currentWalletStats?.chain!}
                        className="w-full h-full"
                      />
                    )}
                  </div>
                  <div className="flex items-center gap-1">
                    {currentWalletStats?.name}{' '}
                    <DownTriangle className="w-3" />
                  </div>
                </div>
                <div className="border-l-[1px] border-primary h-3"></div>
                <CopyWithContent
                  className="w-4 text-tertiary"
                  content={currentWalletStats?.address!}
                />
              </div>
            )}
            {gettingWalletBalance ? (
              <div className="pt-2">
                <CommonSkeleton className="w-[40vw] h-9" />
              </div>
            ) : (
              <TotalUsdValue canClick={true} />
            )}

            <div className="mt-5 flex justify-between text-sm">
              <PressLink
                onClick={() => {
                  sendGAEvent('event', 'send');
                }}
                href="/assets/send"
              >
                <div className="flex items-center justify-center w-16 h-16">
                  <div className="w-16 h-16 group-active:scale-[0.9375] transition-all duration-200 group-active:bg-[#14044F]/70 rounded-2xl flex justify-center items-center bg-[#14044F]">
                    <UpArrow className="w-6 h-6 group-active:opacity-70" />
                  </div>
                </div>
                Send
              </PressLink>
              <PressLink
                onClick={() => {
                  sendGAEvent('event', 'receive');
                }}
                href="/assets/receive"
              >
                <div className="flex items-center justify-center w-16 h-16">
                  <div className="w-16 h-16 group-active:scale-[0.9375] group-active:bg-[#14044F]/70 rounded-2xl flex justify-center items-center bg-[#14044F]">
                    <DownArrow className="w-6 h-6 group-active:opacity-70" />
                  </div>
                </div>
                Receive
              </PressLink>
              <PressLink
                onClick={() => {
                  sendGAEvent('event', 'assets');
                }}
                href="/assets"
              >
                <div className="flex items-center justify-center w-16 h-16">
                  <div className="w-16 h-16 group-active:scale-[0.9375] transition-all duration-200 group-active:bg-[#14044F]/70 rounded-2xl flex justify-center items-center bg-[#14044F]">
                    <CoinTwo className="w-6 h-6 group-active:opacity-70" />
                  </div>
                </div>
                Assets
              </PressLink>
              <PressLink
                onClick={() => {
                  sendGAEvent('event', 'orders');
                }}
                href="/orders"
              >
                <div className="flex items-center justify-center w-16 h-16">
                  <div className="w-16 h-16 group-active:scale-[0.9375] transition-all duration-200 group-active:bg-[#14044F]/70 rounded-2xl flex justify-center items-center bg-[#14044F]">
                    <Timer className="w-6 h-6 group-active:opacity-70" />
                  </div>
                </div>
                Orders
              </PressLink>
              <HapticContainer>
                <div
                  onClick={() => {
                    setShowMore(true);
                  }}
                  className="flex flex-col items-center gap-[0.4rem] cursor-pointer group "
                >
                  <div className="flex items-center justify-center w-16 h-16">
                    <div className="w-16 h-16 group-active:scale-[0.9375] transition-all duration-200 group-active:bg-[#14044F]/70 rounded-2xl flex justify-center items-center bg-[#14044F]">
                      <More className="w-6 h-6 group-active:opacity-70" />
                    </div>
                  </div>
                  More
                </div>
              </HapticContainer>
            </div>
          </div>
        ) : (
          <div className="flex flex-col px-4 pb-4 items-start gap-3">
            <Image
              src="/images/bitbot2.svg"
              width={48}
              height={48}
              alt=""
            />
            <div className="font-bold tracking-[-0.3px] text-2xl">
              Create a Wallet and
              <br />
              Get{' '}
              <span className="bg-gradient-to-r from-[#AEADFF] to-[#E5A8B7] bg-clip-text text-transparent">
                1-5 Bitbot
              </span>{' '}
              Instantly!
            </div>
            <p className="text-base font-semibold flex text-white/60 tracking-[-0.2px] leading-6">
              The world&apos;s first non-custodial Telegram trading bot
            </p>
            <div className="w-[208px]">
              <Button
                onClick={() => {
                  setShowCreateWalletAndLoginDialog(true);
                  sendGAEvent('event', 'click_home_login');
                }}
                type="primary"
                size="xs"
                className="text-base"
              >
                Create Wallet
              </Button>
            </div>
          </div>
        )} */}
        <Card />
        <div className="px-4">
          <HomeTab />
        </div>
        <div className="h-[100px]"></div>
        <ChangeWalletDialog
          open={showChangeWallet}
          toggle={setShowChangeWallet}
          hideCloseIcon
        />
        <MoreDialog open={showMore} toggle={setShowMore} hideCloseIcon />
      </div>
      <TradeSearch />
    </div>
  );
}

function PressLink({
  children,
  className,
  href,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  href: string;
  onClick?: () => void;
}) {
  return (
    <HapticContainer onClick={onClick}>
      <Link
        href={href}
        className={clsx(
          className,
          'group flex flex-col items-center gap-[0.4rem]',
        )}
      >
        {children}
      </Link>
    </HapticContainer>
  );
}
